import React, { useState } from 'react';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
import { Lender } from '../types';
export interface LenderFormProps {
  lender?: Lender;
  onSubmit: (lenderData: Omit<Lender, 'id' | 'createdAt' | 'updatedAt'>) => void;
  onCancel: () => void;
}
export function LenderForm({
  lender,
  onSubmit,
  onCancel
}: LenderFormProps) {
  const [formData, setFormData] = useState({
    name: lender?.name || '',
    fhaSponsorId: lender?.fhaSponsorId || '',
    vaSponsorId: lender?.vaSponsorId || '',
    taxId: lender?.taxId || '',
    insuranceMortgageeClause: lender?.insuranceMortgageeClause || '',
    titleMortgageeClause: lender?.titleMortgageeClause || '',
    street: lender?.address.street || '',
    city: lender?.address.city || '',
    state: lender?.address.state || '',
    zip: lender?.address.zip || '',
    phone: lender?.phone || '',
    email: lender?.email || ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      name: formData.name,
      fhaSponsorId: formData.fhaSponsorId,
      vaSponsorId: formData.vaSponsorId,
      taxId: formData.taxId,
      insuranceMortgageeClause: formData.insuranceMortgageeClause,
      titleMortgageeClause: formData.titleMortgageeClause,
      address: {
        street: formData.street,
        city: formData.city,
        state: formData.state,
        zip: formData.zip
      },
      phone: formData.phone,
      email: formData.email
    });
  };
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-35">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-36">
        <div className="md:col-span-2" data-id="element-37">
          <Input label="Lender Name" value={formData.name} onChange={e => setFormData({
          ...formData,
          name: e.target.value
        })} required data-id="element-38" />
        </div>

        <Input label="FHA Sponsor ID" value={formData.fhaSponsorId} onChange={e => setFormData({
        ...formData,
        fhaSponsorId: e.target.value
      })} required data-id="element-39" />

        <Input label="VA Sponsor ID" value={formData.vaSponsorId} onChange={e => setFormData({
        ...formData,
        vaSponsorId: e.target.value
      })} required data-id="element-40" />

        <Input label="Tax ID" value={formData.taxId} onChange={e => setFormData({
        ...formData,
        taxId: e.target.value
      })} required data-id="element-41" />

        <Input label="Phone" type="tel" value={formData.phone} onChange={e => setFormData({
        ...formData,
        phone: e.target.value
      })} required data-id="element-42" />

        <div className="md:col-span-2" data-id="element-43">
          <Input label="Email" type="email" value={formData.email} onChange={e => setFormData({
          ...formData,
          email: e.target.value
        })} required data-id="element-44" />
        </div>
      </div>

      <div className="border-t border-slate-200 pt-6" data-id="element-45">
        <h3 className="text-lg font-medium text-slate-900 mb-4" data-id="element-46">Address</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-47">
          <div className="md:col-span-2" data-id="element-48">
            <Input label="Street Address" value={formData.street} onChange={e => setFormData({
            ...formData,
            street: e.target.value
          })} required data-id="element-49" />
          </div>

          <Input label="City" value={formData.city} onChange={e => setFormData({
          ...formData,
          city: e.target.value
        })} required data-id="element-50" />

          <Input label="State" value={formData.state} onChange={e => setFormData({
          ...formData,
          state: e.target.value
        })} required data-id="element-51" />

          <Input label="ZIP Code" value={formData.zip} onChange={e => setFormData({
          ...formData,
          zip: e.target.value
        })} required data-id="element-52" />
        </div>
      </div>

      <div className="border-t border-slate-200 pt-6" data-id="element-53">
        <h3 className="text-lg font-medium text-slate-900 mb-4" data-id="element-54">
          Mortgagee Clauses
        </h3>
        <div className="space-y-4" data-id="element-55">
          <Input label="Insurance Mortgagee Clause" value={formData.insuranceMortgageeClause} onChange={e => setFormData({
          ...formData,
          insuranceMortgageeClause: e.target.value
        })} required data-id="element-56" />

          <Input label="Title Mortgagee Clause" value={formData.titleMortgageeClause} onChange={e => setFormData({
          ...formData,
          titleMortgageeClause: e.target.value
        })} required data-id="element-57" />
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-6 border-t border-slate-200" data-id="element-58">
        <Button type="button" variant="secondary" onClick={onCancel} data-id="element-59">
          Cancel
        </Button>
        <Button type="submit" variant="primary" data-id="element-60">
          {lender ? 'Update Lender' : 'Create Lender'}
        </Button>
      </div>
    </form>;
}